module.exports = __webpack_public_path__ + "img/check-false.544c6247.svg";